import * as moment from 'moment';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNProtocol extends CNItem {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'stvaast_protocol';
    }

    get date(): Date {
        if (this.getProperty('DocumentDate')) {
            return moment(this.getProperty('DocumentDate'), 'DD/MM/YYYY').toDate();
        }
        return this.createddate;
    }

    public clone(): any {
        return new CNProtocol();
    }
}
